import React, { useState } from 'react';
import { Pagination, Typography, Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setCategoriesPage } from '../../../redux/category/getAllCategorySlice';

const CatPagination = ({ totalItems, itemsPerPage, start, end, setPage, page, isDispatch = true }) => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const dispatch = useDispatch()

    const handlePageChange = (event, page) => {
        if (isDispatch) {
            dispatch(setPage(page));
        } else {
            setPage(page);
        }
    };

    return (
        <Box display="flex" alignItems="center" justifyContent="space-between" padding={2}>
            <Typography variant="body2"
                sx={{
                    color: '#667085',
                    fontSize: '14px',
                    fontWeight: '500',
                    fontFamily: `'Public Sans', sans-serif`,

                }}>
                Showing {start}-
                {end} from {totalItems}
            </Typography>
            <Pagination
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                shape="rounded"
                siblingCount={1} // Show one sibling page (previous and next)
                boundaryCount={0} // Do not show first and last buttons
                sx={{
                    '& .MuiPaginationItem-root': {
                        fontSize: '1rem',
                        margin: '0 4px',
                        color: '#512DA8',
                        border: '1px solid #E0E2E7',
                        borderRadius: '6px',
                        fontSize: '14px',
                        fontFamily: `'Public Sans', sans-serif`,
                    },
                    '& .Mui-selected': {
                        color: '#fff',
                        backgroundColor: '#512DA8  !important',  // custom color for selected page

                    },
                    '& .MuiPaginationItem-root:hover': {
                        color: '#fff',
                        backgroundColor: '#512DA8', // custom hover color
                    },
                }}
            />
        </Box>
    );
};

export default CatPagination;
